<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="cancel()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Create Profile</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form v-model="valid" ref="addProfileForm"  @submit="save" onSubmit="return false">
                <v-container fluid>
                    <v-layout>
                        <v-flex md4>
                            <v-text-field label="Name"
                                          ref="name"
                                          v-model="profile.name"
                                          :rules="serverValidation('name','Profile Name')"
                                          counter="100"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn outlined type="button" @click="cancel()" color="warning" :disabled="overlay">Cancel</v-btn>
            <v-btn outlined type="button" @click="save()" color="success" :disabled="overlay">Save</v-btn>
            <v-progress-circular
                    :width="3"
                    v-show="overlay"
                    color="red"
                    indeterminate="">
            </v-progress-circular>
        </v-card-actions>
    </v-card>
</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        mixins:[validationMixin],
        data() {
            return {
                overlay: false,
                valid: false,
                profile: {},
                premiseId : null
            }
        },
        methods: {
            open(premiseId) {
                this.reset();
                this.premiseId = premiseId;
                this.$nextTick(this.$refs.name.focus);
            },
            reset() {
                this.profile = {};
                this.violations = [];
                this.premiseId = null;
            },
            save() {
                this.overlay = true;
                this.profile.premiseId = this.premiseId;
                api.profile.post(this.profile).then((profile) => {
                    this.reset();
                    this.$emit('saved',profile);
                    this.$root.$emit('globalMessage','Profile Saved');
                }, (error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.addProfileForm.validate();
                    }
                }).finally(() => this.overlay = false);
            },
            cancel() {
                this.$emit('cancelled');
            }
        }
    }

</script>